type CustomerActivityRefreshListener = () => void;

const listeners = new Set<CustomerActivityRefreshListener>();
let pendingInvalidation = false;

export function subscribeCustomerActivityRefresh(listener: CustomerActivityRefreshListener): () => void {
  listeners.add(listener);
  if (pendingInvalidation) {
    listener();
  }
  return () => {
    listeners.delete(listener);
  };
}

/** Notify all customer-activity consumers to reload immediately (bell, timeline, widgets). */
export function invalidateCustomerActivityRefresh(): void {
  if (!listeners.size) {
    pendingInvalidation = true;
    return;
  }
  pendingInvalidation = false;
  listeners.forEach((listener) => {
    listener();
  });
}
